import { Component, Input } from "@angular/core";

// A small numbered step indicator (done / current / to do) shared by the Import and "Reuse flattened columns" flows.
@Component({
  selector: "adm-steps",
  template: `
    <div style="display: flex; align-items: center; margin: 12px 0 18px; flex-wrap: wrap">
      <ng-container *ngFor="let name of steps; let i = index">
        <div style="display: flex; align-items: center">
          <span
            style="display: inline-flex; width: 26px; height: 26px; border-radius: 13px; align-items: center; justify-content: center; font-weight: bold; color: #fff"
            [style.background]="state(i) === 'todo' ? '#aaa' : state(i) === 'done' ? '#2e7d32' : '#1565c0'"
            >{{ state(i) === "done" ? "&#10003;" : i + 1 }}</span
          >
          <span style="margin: 0 8px 0 6px" [style.font-weight]="state(i) === 'current' ? 'bold' : 'normal'">{{ name }}</span>
        </div>
        <span *ngIf="i < steps.length - 1" style="flex: 0 0 40px; height: 1px; background: #bbb; margin-right: 8px"></span>
      </ng-container>
    </div>
  `,
})
export class AdmStepsComponent {
  @Input() steps: string[] = [];
  // Zero-based index of the current step.
  @Input() current = 0;

  state(index: number): string {
    if (index < this.current) return "done";
    return index === this.current ? "current" : "todo";
  }
}
